/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 메인페이지 컴포넌트
 * 버전 : 1.0
 * 파일명 : HomePage.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * ================================================================
 * 수정일 : 2025-07-02, 강동형 : 저작권 추가, 더보기 버튼 추가에 따른 reset 시점 고도화
 * 수정일 : 2026-02-04, 지역 축제 소식 박스 추가, 장기미방문 학교 제거, 담당지역 불일치 모달 추가
 * ================================================================ */

import { useEffect, useRef } from 'react';
import ScheduleBoard from '../components/main/ScheduleBoard';
import OptionsGrid from '../components/main/OptionsGrid';
import AIServices from '../components/main/AIServices';
import styled from 'styled-components';
import { useSchoolListDialogStore } from 'src/stores/DialogStore';
import SchoolListSheet from 'src/components/main/SchoolListSheet';
import Festival from 'src/components/main/Festival';
import { useStorageStore } from 'src/stores/StorageStore';
import { useModalStore } from 'src/stores/ModalStore';
import { Common_ModalContent_Simple, Common_ModalFooter_SimpleDouble, Common_ModalTitle_AlertCircle } from 'src/components/modals/CommonModal';
import { useNavigate } from 'react-router-dom';

// 최상위 div에 대한 스타일 정의
const HomePageContainer = styled.div`
  background-color: #F9F9F9; /* 원하는 배경색으로 설정 */
  min-height: 100vh; /* 화면 전체 높이 확보 */
`;

function HomePage() {
  const reset = useSchoolListDialogStore((state)=>state.reset)
  const criterion = useSchoolListDialogStore((state)=>state.criterion)
  // ✅ 최신 criterion 값을 항상 저장해두는 ref
  const latestCriterionRef = useRef(criterion);
  const storage = useStorageStore()
  const userInfo = storage.getItem('user').data
  const modalSetField = useModalStore(s=>s.setField)
  const navigate = useNavigate();

  const onClickNavigate = ()=>{
    modalSetField('open',false)
    navigate('/my-info')
  }

  if(userInfo){
    if(userInfo.team_area !== null){
      modalSetField('type','CENTER')
      modalSetField('width','calc(100vw - 20px)')
      modalSetField('padding','20px')
      modalSetField('title',<Common_ModalTitle_AlertCircle title={'담당 지역 확인'}/>)
      modalSetField('content',<Common_ModalContent_Simple content={`현재 설정된 담당 지역이 소속된 팀의 담당 지역과\n일치하지 않습니다. 담당 지역 설정을 확인해 주세요.`} customStyle={{textAlign:'center'}}/>)
      modalSetField('footer',<Common_ModalFooter_SimpleDouble
        customWrapperStyle={{width:'100%'}}
        cancleAction={()=>modalSetField('open',false)}
        customCancleStyle={{width:'96px'}}
        confirmAction={onClickNavigate}
        confirmText="확인하기"
        customConfirmStyle={{width:'100%'}}
        />)
      modalSetField('open',true)
    }
  }

  useEffect(() => {
    latestCriterionRef.current = criterion;
  }, [criterion]);

  useEffect(()=>{
    return()=>{
      const latest = latestCriterionRef.current; 
      if(latest){
        reset(true)
      }
      else{
        reset()
      }
    }
  },[])
  return (
    <HomePageContainer>
      <ScheduleBoard />
      <OptionsGrid />
      <Festival />
      <AIServices />
      <SchoolListSheet/>
    </HomePageContainer>
  );
}

export default HomePage;